import React from "react";
import { BrowserRouter, Route, Link } from "react-router-dom";
import { CbNavigation, CbMobileNav } from './includes/Navigation.jsx'
import { Work, WorkSub, Popup } from './includes/Work.jsx'
import { Home } from './includes/Home.jsx'
import { About } from './includes/About.jsx'
import { Contact } from './includes/Contact.jsx'
import { Imprint } from './includes/Imprint.jsx'
// import { Datenschutz } from './includes/Datenschutz.jsx'
import { ScrollToTop } from './includes/ScrollToTop.jsx'


// const AppContext = React.createContext();

// Lazy load / Preload before route
// https://gist.github.com/goshakkk/a9df8238f43e4ad71f6ae4034482d509
// https://stackoverflow.com/questions/37849933/react-router-how-to-wait-for-an-async-action-before-route-transition
// https://scotch.io/tutorials/lazy-loading-routes-in-react


// const pagebase = '/christophbreitbach';
const pagebase = '/';

// https://medium.com/@joethedave/achieving-ui-animations-with-react-the-right-way-562fa8a91935

class ChristophBreitbach extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      workdata: [],
      fetchok: null,
      izSticky: false,
      stickyThreshold: 10,

      showPopup: false,
      vidurl: "",
      vidthumb: "",
      // creating reference to use on video COMPONENT (could be used on whatever)
      videoRef: React.createRef()
    };

  }

  closePopup() {
    this.setState({
      showPopup: false
    });
    // as we assigned this to the video COMPONENT we can use its methods
    this.state.videoRef.current.stopVideo();
  }

  openPopup(url, thumb) {
    this.setState({
      vidurl: url,
      vidthumb: thumb,
      showPopup: true
    });
  }

  componentDidMount() {

    // INIT STICKY
    window.addEventListener('scroll', this._calcTranslation.bind(this));
    this._calcTranslation();

    // GET JSON DATA
    fetch( process.env.PUBLIC_URL + '/data.json', { method: 'GET' })
        .then(response => response.json())

        .then((workdata) => {
          this.setState({ workdata: workdata });
          this.setState({ fetchok: true });
        })

        .catch(function(err) {
          // console.error("error", err);
          this.setState({ workdata: [] })
          this.setState({ fetchok: false })
        }.bind(this));

  }

  // STICKY tester, called on scroll
  _calcTranslation() {
    var _window = window;

    var scrollPos = _window.scrollY;

    if (scrollPos < this.state.stickyThreshold) {
      if (this.state.izSticky)
        this.setState({izSticky: false});
    } else {
      if (!this.state.izSticky)
        this.setState({izSticky: true});
    }

  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this._calcTranslation)
  }

  render() {

    return (
        <BrowserRouter basename={pagebase}>

          <ScrollToTop>

            <div id="outer-container">

              <CbMobileNav/>

              <main id="page-wrap">

                <Route render={(props) => {
                  let BackgroundStyle = '';
                  if (props.location.pathname.indexOf('/work/') === 0) {
                    BackgroundStyle += ' cb-bkgr-white';
                  } else if (props.location.pathname === '/') {
                    BackgroundStyle += ' cb-no-padding';
                  }
                  return (
                      <div className={(this.state.izSticky?"sticky":"")}>

                        <Route exact path="/" component={CbNavigation}/>
                        <Route path="/:id" component={CbNavigation}/>

                        <Route exact path="/" component={Home}/>

                        <div className={"cb-background clearfix" + BackgroundStyle}>
                          <section className="container" id="main">

                            <Route exact path="/work" render={(props)=>
                                <Work {...props} workdata={ this.state.workdata }/>
                            }/>

                            <Route exact path="/work/:id" render={(props)=>
                                <WorkSub {...props}
                                         workdata={ this.state.workdata }
                                         openPopup={ this.openPopup.bind(this) }/>
                            }/>

                            <Route path="/about" component={About}/>
                            <Route path="/contact" component={Contact}/>
                            <Route path="/impressum" component={Imprint}/>
                          </section>
                        </div>

                        <Route path="/:id" component={CbFooter}/>

                      </div>
                  );
                }}
                />

              </main>

              <Popup closePopup={this.closePopup.bind(this)}
                     vidurl={ this.state.vidurl }
                     show={ this.state.showPopup }
                     // assigning a reference to the COMPONENT means we can later call its methods!
                     ref={ this.state.videoRef }
              />

            </div>

          </ScrollToTop>

        </BrowserRouter>
    );
  }
};





const CbFooter = () => (
    <div className="cb-footer">

      <div className="cb-footermenu">

        <div className="cb-authorname">
          &copy; Christoph Breitbach
        </div>

        <div className="cb-separator">|</div>

        <div className="cb-authordoes">
          <Link to="/impressum">
            Impressum
          </Link>
        </div>

        {/*<div className="cb-separator">|</div>*/}

        {/*<div className="cb-authordoes">*/}
          {/*<Link to="/datenschutz">*/}
            {/*Datenschutz*/}
          {/*</Link>*/}
        {/*</div>*/}

        {/*<Link to="/" className="cb-navlogo">*/}
          {/*<img src="/img/cbr_logo.svg" />*/}
        {/*</Link>*/}

      </div>

    </div>
)



export default ChristophBreitbach;


// WEBPACK FOOTER //
// ./src/App.js